import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AuthUserContext,
  ButtonBar, PersonSelect, ScreenHeader
} from '../../components';
import { useIndex } from '../../hooks';

const powerOptions = [
  {
    label: 'Withhold or withdraw life-sustaining treatment',
    description: 'Allow your agent to make decisions about life-sustaining treatments.',
    name: 'powers',
  },
  {
    label: 'Authorize artidficial nutrition and hydration',
    description: 'Allow your agent to decide on artificial nutrition and hydration.',
    name: 'powers',
  },
  {
    label: 'Authorize organ donation',
    description: 'Allow your agent to make decisions regarding organ donation.',
    name: 'powers',
  },
  {
    label: 'Authorize autopsy',
    description: 'Allow your agent to authorize an autopsy if necessary.',
    name: 'powers',
  },
  {
    label: 'Burial or cremation arrangements',
    description: 'Allow your agent to make decisions about burial or cremation arrangements.',
    name: 'powers',
  }
];

export function NewHDHealthcareAgentDetails() {
  const navigate = useNavigate();
  
  const { user } = React.useContext(AuthUserContext);
  
  const { data, update } = useIndex('people', { user_id: user?.id });
    
  const handleBack = useCallback(() => {
    // Handle back navigation
    navigate(-1);
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../guardian-conservator');
  }, [ navigate ]);

  const people = data
    .filter((person) => person.linkedUserId !== user?.id);

  const options = people.map((person) => ({
    label: `${person.firstName} ${person.lastName}`,
    ...person
  }));

  return (
    <div className="new-fa-disposition">
      <ScreenHeader 
        title="Healthcare Agent"
        description="Would you like to designate a healthcare agent to make decisions on your behalf?"
        steps={6}
        step={6}
        handleBack={handleBack}
      />
      
      <PersonSelect 
        selected={null}
        handleSelect={() => {}}
        handleClickableOption={() => {}}
        options={options}
      />

      <CheckboxCardOptionGroup options={powerOptions} />

      <ButtonBar
        handlePrimary={handleNext}
      />
    </div>
  );
}

export function CheckboxCardOptionGroup({ options }) {
  return (
    <div className="radio-card-button-group">
      {options.map((option) => (
        <CheckboxCardOption
          key={option.id}
          id={option.id}
          label={option.label}
          description={option.description}
          name={option.name}
          value={option.id}
          icon={option.icon}
        />
      ))}
    </div>
  );
}

export function CheckboxCardOption({ id, label, description, name, value, icon }) {
  return (
    <div className="radio-card-button-option">
      <input type="checkbox" id={id} name={name} value={value} />
      <div className="radio-card-button-content">
        <div className="radio-card-button-header">
          { icon && <span className="material-symbols-outlined">{icon}</span> }
          <h4>{label}</h4>
        </div>
        <h6>{description}</h6>
      </div>
    </div>
  );
}